import React, { ReactElement } from 'react'
import { useTranslation } from 'next-i18next'
import Head from 'next/dist/shared/lib/head'
import PublicDashboardHeader from 'shared/components/public-dashboard-header'

function UnsubscribePageLayout({ children }: React.PropsWithChildren<any>) {
  const { t } = useTranslation()

  return (
    <>
      <Head>
        <title>{t('unsubscribe_page.unsubscribe.title')}</title>
      </Head>
      <>
        <PublicDashboardHeader />
        <div className="grid h-[calc(100vh-69px)] place-items-center px-5">
          <div className="mx-auto max-w-lg rounded-lg bg-background-secondary px-12 pb-[56px] pt-12 text-center shadow-lg lg:w-[500px]">
            {children}
          </div>
        </div>
      </>
    </>
  )
}

export const getUnsubscribePageLayout = (page: ReactElement) => (
  <UnsubscribePageLayout>{page}</UnsubscribePageLayout>
)
